<template>
  <div>
    <van-nav-bar :title="generateCustomizeString('accountCredit')" :left-text="generateCustomizeString('goBack')" left-arrow @click-left="onClickLeft" :sticky="true" fixed />
    <div style="margin-top: 46px;">
      <van-cell :title="generateCustomizeString('nowCredit')" :value="'NZD $' + parseFloat(this.creditInfo.credits / 100 * 1000 / 1000).toFixed(2)" style="font-size: 16px; line-height: 36px; color: #fea812;" />
    </div>
    <van-panel :title="generateCustomizeString('editCredit')" style="margin-top: 5px;">
      <van-tabs v-model="active">
        <van-tab title="增加余额">
          <div>
            <van-cell-group>
              <van-field v-model="addCreditValue" label="NZD $" :placeholder="generateCustomizeString('inputCredit')" label-align="center"></van-field>
              <van-field v-model="addComment" :label="generateCustomizeString('comment')" label-align="center"></van-field>
            </van-cell-group>
          </div>
          <div style="padding: 10px; text-align: right;">
            <van-button size="small" @click="addCredit">{{generateCustomizeString('confirm')}}</van-button>
          </div>
        </van-tab>
        <van-tab title="减少余额">
          <div>
            <van-cell-group>
              <van-field v-model="reduceCreditValue" label="NZD $" :placeholder="generateCustomizeString('inputCredit')" label-align="center"></van-field>
              <van-field v-model="reduceComment" :label="generateCustomizeString('comment')" label-align="center"></van-field>
            </van-cell-group>
          </div>
          <div style="padding: 10px; text-align: right;">
            <van-button size="small" @click="reduceCredit">{{generateCustomizeString('confirm')}}</van-button>
          </div>
        </van-tab>
      </van-tabs>
    </van-panel>
    <van-steps direction="vertical" :active="0" active-color="#fea812" style="margin-top: 5px; padding-bottom: 10px;">
      <van-step  v-for="(creditLog, index) in creditOperationLog" :key="index">
        <div style="line-height: 20px;">{{generateCustomizeString('operator')}} {{creditLog.operator}}</div>
        <div style="line-height: 26px;">{{generateCustomizeString('operationTime')}} {{creditLog.operatingTime | toLocalTime}}</div>
        <div style="line-height: 26px;">{{generateCustomizeString('creditAmount')}} {{creditLog.creditAmount}}</div>
        <div style="line-height: 26px;">{{generateCustomizeString('operationDetails')}} {{generateCustomizeString(creditLog.operationDetails)}}</div>
        <div style="line-height: 26px;">{{generateCustomizeString('comment')}} {{creditLog.comment}}</div>
      </van-step>
    </van-steps>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Row, Col, Tag, Panel, Button, Field, NavBar, Step, Steps, Cell, CellGroup, Toast, Tab, Tabs } from 'vant'
import request from '@/utils/request'
import dayjs from 'dayjs'

export default {
  name: 'CustomerCredit',
  data() {
    return {
      addCreditValue: null,
      addComment: '',
      reduceCreditValue: null,
      reduceComment: '',
      creditInfo: [],
      creditOperationLog: [],
      active: 0
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [Panel.name]: Panel,
    [Button.name]: Button,
    [Field.name]: Field,
    [NavBar.name]: NavBar,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  methods: {
    generateCustomizeString,
    onClickLeft() {
      this.$router.push({
        name: 'CustomerDetail',
        params: { customerId: this.creditInfo.customer_id }
      })
    },
    fetchCredit() {
      request({
        url: 'credits/' + this.$route.params.creditsId,
        method: 'get'
      })
        .then(response => {
          this.creditInfo = response.data

          // Operation Log
          var logData = []
          for (let i = 0; i < response.data.credits_records.length; i++) {
            var obj = {}
            obj.operator = response.data.credits_records[i].operator
            obj.operatingTime = response.data.credits_records[i].created_at
            // obj.operatingTime = dayjs(new Date(obj.operatingTime + ' UTC')).format('YYYY-MM-DD HH:mm:ss')
            obj.creditAmount = 'NZD $' + response.data.credits_records[i].quantity / 100 * 1000 / 1000
            obj.operationDetails = response.data.credits_records[i].status_name
            obj.comment = response.data.credits_records[i].comment

            logData[i] = obj
          }
          this.creditOperationLog = logData
          Toast.clear()
        })
        .catch(error => {
          Toast.clear()
          console.warn(error)
        })
    },
    addCredit() {
      var data = {
        delta_credits: '+' + this.addCreditValue * 100,
        comment: this.addComment
      }
      request({
        url: 'customer/credits/' + this.$route.params.creditsId,
        method: 'post',
        data
      })
        .then(response => {
          if (response.status === 0) {
            Toast.success(this.generateCustomizeString('updateCreditSuccess'))
          } else {
            Toast.fail(this.generateCustomizeString('updateCreditFail'))
          }
          this.fetchCredit()
          this.addCreditValue = null
          this.addComment = ''
        })
        .catch(error => {
          console.log(error)
          Toast.fail(this.generateCustomizeString('updateCreditFail'))
        })
    },
    reduceCredit() {
      var data = {
        delta_credits: '-' + this.reduceCreditValue * 100,
        comment: this.reduceComment
      }
      request({
        url: 'customer/credits/' + this.$route.params.creditsId,
        method: 'post',
        data
      })
        .then(response => {
          if (response.status === 0) {
            Toast.success(this.generateCustomizeString('updateCreditSuccess'))
          } else {
            Toast.fail(this.generateCustomizeString('updateCreditFail'))
          }
          this.fetchCredit()
          this.reduceCreditValue = null
          this.reduceComment = ''
        })
        .catch(error => {
          console.log(error)
          Toast.fail(this.generateCustomizeString('updateCreditFail'))
        })
    }
  },
  created: function() {
    Toast.loading({
      mask: true,
      forbidClick: true,
      message: this.generateCustomizeString('loading')
    })
    this.fetchCredit()
  }
}
</script>

<style lang="less" scoped>
</style>
<style type="text/css">
  .van-field__control {
    line-height: 24px !important;
  }
</style>
